import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import useLogic from './logic';
import './index.scss';
import { areFiltersApplied } from '../service';
import { GeckoIcon } from 'ui';

const QuickFiltersDropdownItem = (props) => {
  const { label, value, filters, onFilterSelect } = props;
  const isApplied = areFiltersApplied(value, filters);
  return (
    <Dropdown.Item
      className="QuickFiltersDropdown__menu-item"
      onClick={() => onFilterSelect(value)}
      title={label}
      aria-pressed={isApplied}
      role="menuitem"
    >
      <div>{label}</div>
      {isApplied ? (
        <div>
          <i className="far fa-check" />
        </div>
      ) : null}
    </Dropdown.Item>
  );
};

const QuickFiltersDropdownSection = (props) => {
  const { label, options, filters, onFilterSelect } = props;
  const menuItems = options.map((option, index) => {
    const { label, value } = option;
    return (
      <QuickFiltersDropdownItem
        key={index}
        label={label}
        value={value}
        filters={filters}
        onFilterSelect={onFilterSelect}
      />
    );
  });
  return (
    <>
      <Dropdown.Header>{label}</Dropdown.Header>
      {menuItems}
    </>
  );
};

const QuickFiltersDropdown = (props) => {
  const {
    filters,
    quickFilters,
    onFilterSelect,
    isDropdownOpen,
    toggleDropdown,
  } = useLogic(props);

  const renderQuickFilterItem = (quickFilter, index, quickFilters) => {
    const { label, value, options } = quickFilter;
    const isLastItem = index === quickFilters.length - 1;
    if (options !== undefined) {
      return (
        <React.Fragment key={index}>
          <QuickFiltersDropdownSection
            label={label}
            options={options}
            filters={filters}
            onFilterSelect={onFilterSelect}
          />
          {isLastItem ? null : <Dropdown.Divider />}
        </React.Fragment>
      );
    }
    return (
      <QuickFiltersDropdownItem
        key={index}
        label={label}
        value={value}
        filters={filters}
        onFilterSelect={onFilterSelect}
      />
    );
  };

  const menuItems = quickFilters.map(renderQuickFilterItem);

  return (
    <Dropdown
      className="QuickFiltersDropdown"
      show={isDropdownOpen}
      onToggle={toggleDropdown}
      drop="down"
    >
      <Dropdown.Toggle
        variant="secondary"
        className="gecko-btn gecko-ui-material btn btn-default"
        disabled={props.disabled}
        as="button"
      >
        {props.isLoading ? (
          <GeckoIcon icon="far fa-spinner spin" />
        ) : (
          <GeckoIcon icon="far fa-bars-filter icon-left" />
        )}
        Quick Filters
      </Dropdown.Toggle>
      <Dropdown.Menu role="menu" className="gecko-dropdown-menu">
        <div className="QuickFiltersDropdown__menu-container">{menuItems}</div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default QuickFiltersDropdown;
